/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Modals\ModalAddCar\ModalAddCar.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Monday March 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 23rd September 2024 03:27:30
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { MouseEventHandler, useState } from "react";
import {Form, Button, Col} from "react-bootstrap";
import MyModal from "Content/Modals/MyModal";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Modals/ModalUser/ModalUser.module.css";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import CarService from "Services/Car/CarService";
import LoadingLines from "Content/LoadingScreen/LoadingLines/LoadingLines";
import { handleLine } from "Utils/Response.utils";
import { useNavigate } from "react-router-dom";
import RouterPathResolver from "Config/Router/RouterPathResolver";

type ModalProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    title: string,
    archive: boolean,
};

function ModalAddCar(props: ModalProps) {
    const navigate = useNavigate();
    const [isSendable, setIsSendable] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [file, setFile] = useState<File>();
    const [additionnalText, setAdditionnalText] = useState<JSX.Element[]>([]);
    const [lines, setLines] = useState<{key:string, value:string}[]>([]);

    const closeModal= () => {
        setOpenModal(false);
        setAdditionnalText([]);
    }

    const manageMyRespDisplay = (myResult: {[key:string]: string } | string) => {
        const myRes: JSX.Element[] = [];

        let data: { [key: string]: string } = {};

        if (typeof myResult === "string") {
          try {
            data = JSON.parse(myResult);
          } catch (e) {
            setAdditionnalText([<p className={"m-1"} key={myResult}>{myResult}</p>]);
            return;
          }
        } else {
          data = myResult;
        }

        for (const immatOrVin in data) {
            myRes.push(<p className={"m-1"} key={immatOrVin}>{immatOrVin} : {data[immatOrVin]}</p>);
        }
        if (myRes.length > 0)
            setAdditionnalText(prev => [...prev, ...myRes]);
    }

    const HandleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setSpinner(true);
        if (file) {
            setLines([]);
            CarService.addNewCars(file, props.archive, handleLine(setLines)).then(res => {
                setAdditionnalText([<Button className={"mb-2"} onClick={() => navigate(`${RouterPathResolver.pathEditMessage.path}`)}>{translator.decode("dynamic.prepareMessage")}</Button>])
                manageMyRespDisplay(res);
                setIsOkay(true);
                setOpenModal(true);
                setSpinner(false);
            }).catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    // Legacy
                    if (typeof error.response.data.errors === "string") {
                        setAdditionnalText([<span className={"m-1"}>Une erreur est survenue: {error.response.data.errors}</span>]);
                    } else
                        setAdditionnalText([<span className={"m-1"}>Une erreur est survenue: {error.data.errors}</span>]);
                } else if (error.message)
                    manageMyRespDisplay(error.message);
                setIsOkay(false);
                setOpenModal(true);
                setSpinner(false);
            });
        } else
            setIsSendable(false);
    };

    function setFilePicking(e: any) {
        if (e.target.files.length > 0) {
            setFile(e.target.files[0]);
            setIsSendable(true);
        } else {
            setFile(undefined);
            setIsSendable(false);
        }
    };

    return(
        <>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<Button disabled={!isSendable} onClick={(e) => {HandleSubmit(e)}}>{translator.decode("dynamic.create")}</Button>); })()} title={props.title} className={`${Styles.myModal}`}>
                {
                    spinner ?
                        <div className={`${Styles.spinnerHolder}`}>
                            {/* <LoadingScreen /> */}
                            <LoadingLines lines={lines} />
                        </div>
                        :null
                }
                {
                    props.archive ?
                    <h1>{translator.decode("car.archiveWarning")}</h1>
                    : null
                }
                <Form className={`${Styles.formHolder}`}>
                    <Form.Group className={`${Styles.formfield}`} >
                        <Form.Label>
                            {translator.decode("dynamic.import")}:
                        </Form.Label>
                        <Col>
                            <Form.Control type="file" onChange={setFilePicking} accept=".xlsx"/>
                        </Col>
                    </Form.Group>
                </Form>
            </MyModal>
            <ModalConfirmation show={openModal} onClose={() => closeModal()} closeModal={() => closeModal()} isOkay={isOkay} additionnalMessage={additionnalText}/>
        </>
    )
}

export default ModalAddCar;
